import FormsHandler from "../forms-handler/forms-handler";

export default class AuthModal {
	constructor(el) {
		if (!el) return false;

		this.root = el;
        
		this.init();
	}

	init() {
        this.form = this.root.querySelector("form");
		this.handler = new FormsHandler(this.form, this.onSuccess.bind(this));
    }
    
    onSuccess(res) {
        if (res.status === "error" && res.message) {
            const error = this.form.querySelector("[data-auth-modal-error]");
            if (error) {
                error.classList.remove("is-hidden");
                error.innerHTML = res.message;
            }
        } else if (res.status === "ok") {
            window.dataLayer = window.dataLayer || []; 
			dataLayer.push({
				'event': 'LoginSuccess'
            });
            $(document).trigger("auth-success");
        }
    }
}
